const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Mobile No",
    dataIndex: "mobile",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Deleted Date",
    dataIndex: "deleted_at",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    fixed: "right",
  },
];

export default columns;
